<template>
    <div>
        <van-nav-bar :title="title" left-text="返回" @click-left="back" fixed left-arrow />
        <div class="hour-list">
            <van-cell v-for="(item, index) in rows" :key="index" :title="item.projectName || '未命名项目'" :label="item.date">
                <div>工时 {{ item.workingTime }}h</div>
                <div v-if="Number(item.overtimeHours) > 0">加班 {{ item.overtimeHours }}h</div>
                <div>{{ stateText(item.state) }}</div>
            </van-cell>
            <van-empty v-if="loaded && rows.length === 0" description="本月暂无数据" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            filter: "overtime",
            month: "",
            range: "",
            rows: [],
            loaded: false,
            stateMap: ["待审核", "已通过", "已驳回", "待提交"]
        };
    },
    computed: {
        title() {
            const map = {
                overtime: "加班工时",
                rejected: "驳回工时",
                pending: "待提交工时"
            };
            return map[this.filter] || "工时明细";
        }
    },
    created() {
        this.filter = this.$route.query.filter || "overtime";
        this.month = this.$route.query.month || "";
        this.range = this.$route.query.range || "";
        this.load();
    },
    methods: {
        back() {
            history.back();
        },
        stateText(state) {
            if (state == null || state < 0 || state >= this.stateMap.length) {
                return "";
            }
            return this.stateMap[state];
        },
        load() {
            this.$axios.post("/report/getMyMonthOverview", { month: this.month, range: this.range })
                .then(res => {
                    this.loaded = true;
                    if (res.code !== "ok" || !res.data) {
                        this.$toast.fail(res.msg || "获取失败");
                        return;
                    }
                    const items = res.data.items || [];
                    this.rows = items.filter(item => {
                        if (this.filter === "overtime") {
                            return item.overtime === true || item.overtime === 1 || Number(item.overtimeHours) > 0;
                        }
                        if (this.filter === "rejected") {
                            return Number(item.state) === 2;
                        }
                        if (this.filter === "pending") {
                            return Number(item.state) === 3;
                        }
                        return true;
                    });
                }).catch(() => {
                    this.loaded = true;
                    this.$toast.fail("获取失败");
                });
        }
    }
};
</script>

<style lang="less" scoped>
.hour-list {
    margin-top: 46px;
}
</style>
<style lang="less">
.van-nav-bar .van-icon,
.van-nav-bar__text {
    color: #20a0ff;
}
</style>
